import React, { useRef, useState, useEffect, useCallback } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import TypingEffect from '../Analysis/TypingEffect';
import JSZip from "jszip";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../global";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import { PDFDocument } from 'pdf-lib';

const FileUploadModal = ({ issupplementModalOpen, closesupplementModal, tokensData, selectedFile, handleContinueClick, fetchAllCases }) => {

  const supfileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 100;

  const totalTokens = parseFloat(tokensData?.Total_token) || 0;
  const usedTokens = parseFloat(tokensData?.Used_token) || 0;
  const AVALABLE_CREDIT = Math.max(totalTokens - usedTokens, 0);

  const [SupUploadProgress, setSupSupUploadProgress] = useState(0);
  const [isSupUploading, setIsSupUploading] = useState(false);
  const [isSuploading, setIsSuploading] = useState(false);
  const [isSupfilevalidating, setIsSupfilevalidating] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selecteditem, setSelecteditem] = useState([]);
  const [removingFileIndex, setRemovingFileIndex] = useState(null);
  // New states
  const [firstDone, setFirstDone] = useState(true);
  const [secondDone, setSecondDone] = useState(true);

  const [step, setStep] = useState(1);
  const [messagesTyping, setMessagesTyping] = useState(true);

  const [ogAgentlist, setogAgentlist] = useState([]);
  const [agentlist, setagentlist] = useState([]);
  const [ogagentassistantlist, setogagentassistantlist] = useState([]);
  const [agentassistantlist, setagentassistantlist] = useState([]);
  const [ogadditionalappslist, setogadditionalappslist] = useState([]);
  const [additionalappslist, setadditionalappslist] = useState([]);
  const [loading, setLoading] = useState(true);

  const [agentPrompts, setAgentPrompts] = useState({});
  const [selectedPromptAgent, setSelectedPromptAgent] = useState("");
  const [currentPrompt, setCurrentPrompt] = useState("");
  const [editPromptInfo, setEditPromptInfo] = useState({ agentId: null, index: null });
  const [showPromptSection, setShowPromptSection] = useState(false);


  useEffect(() => {
    if (selectedFile) {

      setSelecteditem(selectedFile)
      fetchDetails();
    }
  }, [selectedFile]);


  const handleSupFileInputChange = async (e) => {
    try {
      setIsSupfilevalidating(true);

      const files = Array.from(e.target.files);

      const existingFileNames = selectedFiles.map(file => file.fileName);
      const newFileNames = files.map(file => file.name);
      const duplicateFiles = newFileNames.filter(name => existingFileNames.includes(name));
      if (duplicateFiles.length > 0) {
        toast.error("The file name already exists!");
        e.target.value = "";
        setIsSupfilevalidating(false);
        return;
      }
      const file = files[0];
      const fileSize = file.size;
      const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert MB to bytes

      let totalSize = 0;
      for (let i = 0; i < files.length; i++) {
        totalSize += files[i].size;
      }

      if (totalSize > MAX_FILE_SIZE_BYTES) {
        toast.error(`The total file(s) size exceeds ${MAX_FILE_SIZE_MB} MB. Please upload smaller files.`);
        e.target.value = ""; // Clear the file input
        setIsSupfilevalidating(false);
        return;
      }

      let totalPagesCount = 0;
      let allFiles = [];


      for (let file of files) {
        try {
          if (file.type === "application/pdf") {
            // PDF: calculate pages
            const arrayBuffer = await file.arrayBuffer();
            const pdfDoc = await PDFDocument.load(arrayBuffer);
            totalPagesCount += pdfDoc.getPageCount();
            allFiles.push({ file, name: file.name });
          } else if (file.type === "application/zip" || file.type === "application/x-zip-compressed") {
            // ZIP: read PDFs inside and calculate pages
            try {
              const zip = await JSZip.loadAsync(file);
              const pdfFiles = Object.values(zip.files).filter(f => f.name.endsWith(".pdf"));
              if (zip.password) {
                toast.error("The ZIP file is password-protected. Please upload an unprotected ZIP.");
                e.target.value = "";
                setIsSupfilevalidating(false);
                return;
              }
              for (let pdfFile of pdfFiles) {
                try {
                  const arrayBuffer = await pdfFile.async("arraybuffer");
                  const pdfDoc = await PDFDocument.load(arrayBuffer);
                  totalPagesCount += pdfDoc.getPageCount();
                  allFiles.push({ file, name: file.name });
                } catch (err) {
                  if (err.message.includes("Password") || err.message.includes("encrypted")) {
                    toast.error(`The PDF file "${pdfFile.name}" is password-protected. Please upload an unprotected file.`);
                  } else {
                    toast.error("Invalid or corrupted PDF file.");
                  }
                  e.target.value = "";
                  setIsSupfilevalidating(false);
                  console.error("PDF parsing error inside ZIP:", err);
                  return;
                }
              }
            } catch (err) {
              console.log(err.message)
              if (err.message.includes("Encrypted") || err.message.includes("Password")) {
                toast.error("The ZIP file is password-protected. Please upload an unprotected ZIP.");
              } else {
                toast.error("The ZIP file is corrupted or invalid.");
              }
              console.error("ZIP file error:", err);
              e.target.value = "";
              setIsSupfilevalidating(false);
              return;
            }
          } else {
            toast.error("Invalid or corrupted file.");
          }
        } catch (err) {
          if (err.message.includes("Password") || err.message.includes("encrypted")) {
            toast.error("PDF is password-protected. Please upload an unprotected file.");
          } else {
            toast.error("Invalid or corrupted PDF file.");
          }
          console.error("PDF parsing error:", err);
          e.target.value = "";
          setIsSupfilevalidating(false);
          return;
        }
      }


      const totalWithExisting = (selecteditem?.casePageCount || 0) + (selecteditem?.supplement_page || 0) + totalPagesCount;

      if (totalWithExisting > AVALABLE_CREDIT) {
        toast.error(
          `Insufficient credit: available ${AVALABLE_CREDIT} page credits, but ${totalWithExisting} pages requested.`
        );
        if (supfileInputRef.current) {
          supfileInputRef.current.value = "";
        }
        setIsSupfilevalidating(false);
        setSupSupUploadProgress(0);
        return;
      }

      setIsSupfilevalidating(false);

      setIsSupUploading(true);


      try {
        const userid = localStorage.getItem("userid");
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append("file", files[i]);
        }

        formData.append("userId", userid);
        formData.append("mode", "validate_supplement");
        if (selecteditem?.sessionId) {
          formData.append("sessionId", selecteditem.sessionId);
        }
        setFirstDone(false);
        setSecondDone(false);
        const response = await axios.post(`${API_BASE_URL}add_supplement`, formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setSupSupUploadProgress(percentage);
              }
            },
          });


        if (response.data.status === 1) {
          const responsedata = response.data.validated_data;
          setSelecteditem((prev) => ({
            ...prev,
            sessionId: responsedata.sessionId,
            supplement_page: responsedata.totalPages,
            total_page: responsedata.totalPages + prev.casePageCount,
          }));
          setSelectedFiles(responsedata?.filesList);
          setIsSupUploading(false);
          setSupSupUploadProgress(0)
          e.target.value = "";
        } else {
          toast.error(response.data.message || "");
        }
      } catch (err) {
        console.error("Error while SupUploading files:", err);

      } finally {
        setIsSupUploading(false);
      }

      console.log(totalPagesCount)

    } catch (error) {
      // Detect corrupted or password-protected files
      if (error.message.includes("Password") || error.message.includes("encrypted")) {
        toast.error("PDF is password-protected. Please upload an unprotected file.");
      } else {
        toast.error("Invalid or corrupted PDF file.");
      }
      console.error("PDF parsing error:", error);
      e.target.value = "";
    }
  };

  const handleRomove = useCallback(async (index, file) => {
    try {
      setRemovingFileIndex(index);
      const userid = localStorage.getItem("userid");
      const formData = new FormData();
      formData.append("userId", userid);
      formData.append("mode", "delete_supplement");
      formData.append("file_name", file);
      if (selecteditem?.sessionId) {
        formData.append("sessionId", selecteditem.sessionId);
      }
      const response = await axios.post(`${API_BASE_URL}add_supplement`, formData,
      );


      if (response.data.status === 1) {
        const responsedata = response.data.validated_data;
        setSelecteditem((prev) => ({
          ...prev,
          sessionId: responsedata.sessionId,
          supplement_page: responsedata.totalPages,
          total_page: responsedata.totalPages + prev.casePageCount,
        }));
        setSelectedFiles(responsedata?.filesList);
        if (responsedata?.filesList.length === 0) {
          setSelecteditem(selectedFile);
          setFirstDone(false);
          setSecondDone(false);
          if (supfileInputRef.current) {
            supfileInputRef.current.value = "";
          }
          setStep(1);
        }

      } else {
        toast.error(response?.data?.message || "Error while removing the file");
      }
    } catch (err) {
      console.error("Error while removing the file:", err);
      toast.error("An error occurred while removing the file.");
    } finally {
      setRemovingFileIndex(null);
    }

  }, [selectedFiles]);

  const handleUpload = async (event) => {
    event?.preventDefault();
    setIsSuploading(true);
    const selectedAgents = agentlist.filter(a => a.agentIsSelected === 1);
    const selectedAgentassistants = agentassistantlist.filter(a => a.agentIsSelected === 1);
    const selectedAdditionalapps = additionalappslist.filter(a => a.agentIsSelected === 1);

    const formData = new FormData();

    formData.append("mode", "submit_supplement");
    if (selecteditem) {
      formData.append("sessionId", selecteditem?.sessionId);
      formData.append("caseId", selecteditem?.caseId);
      formData.append("service_id", selecteditem?.caseServiceId);
      // formData.append(
      //   "summary_agents",
      //   JSON.stringify(selectedAgents.map(a => a.agentSummaryId))
      // );
      // formData.append(
      //   "assistant_agents",
      //   JSON.stringify(selectedAgentassistants.map(a => a.agentAssistantId))
      // );
      (selectedAgents || []).forEach((a) =>
        formData.append("summary_agents[]", a.agentSummaryId)
      );
      (selectedAgentassistants || []).forEach((assistant) =>
        formData.append("assistant_agents[]", assistant.agentAssistantId)
      );
      (selectedAdditionalapps || []).forEach((apps) =>
        formData.append("apps_feature[]", apps.commonAppId)
      );
    }
    formData.append("userId", localStorage.getItem("userid") || 0);
    const userPromptArray = [];

    Object.entries(agentPrompts).forEach(([agentId, prompts]) => {
      prompts.forEach((prompt) => {
        userPromptArray.push({
          userPromptDescription: prompt,
          userPromptAgentId: parseInt(agentId, 10),
        });
      });
    });

    // ✅ Now append as JSON string
    formData.append("userPrompt", JSON.stringify(userPromptArray));


    try {
      const response = await axios.post(`${API_BASE_URL}add_supplement`, formData);

      if (response.data.message === "Supplement file added successfully") {
        toast.success("Supplement file added successfully");

        if (response.data.case_id) {
          setIsSuploading(false);
          setStep(1);
          if (supfileInputRef.current) {
            supfileInputRef.current.value = "";
          }
          setFirstDone(false);
          setSecondDone(false);
          setSelecteditem(null);
          setSelectedFiles([]);
          localStorage.setItem("caseID", response.data.case_id);
          window.dispatchEvent(new Event("caseIDUpdated"));
          localStorage.setItem("caseUploaded", "Your document has been successfully uploaded!");
          setTimeout(() => localStorage.removeItem("caseUploaded"), 3000);
          closesupplementModal();
          handleContinueClick();
          fetchAllCases();
        }
      } else {
        toast.error(`Upload failed: ${response.data.message}`);
        setIsSuploading(false);

      }
    } catch (error) {
      setSelectedFiles([]);
      setIsSuploading(false);
      const message = error?.message || "An error occurred";
      toast.error(`Upload failed: ${message}`);
    }

  };


  // const handleClose = () => {
  //   if (selectedFiles && selectedFiles.length > 0) {
  //     // Ask for confirmation before closing
  //     const confirmClose = window.confirm(
  //       "You have uploaded supplement files that are not submitted yet. Do you really want to close?"
  //     );
  //     if (!confirmClose) {
  //       return; // Stop closing
  //     }
  //   }

  //   // Reset state before closing
  //   setSelectedFiles([]);
  //   setSelecteditem(null);
  //   setFirstDone(false);
  //   setSecondDone(false);
  //   if (supfileInputRef.current) {
  //     supfileInputRef.current.value = "";
  //   }

  //   closesupplementModal(); // Trigger parent close
  // };

  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const handleClose = () => {
    if (selectedFiles && selectedFiles.length > 0) {
      // Show confirmation modal instead of closing directly
      setPendingAction(() => () => {
        // Run this when user confirms "Yes, Leave"
        setSelectedFiles([]);
        setStep(1);
        setSelecteditem(null);
        setFirstDone(false);
        setSecondDone(false);
        if (supfileInputRef.current) {
          supfileInputRef.current.value = "";
        }
        closesupplementModal();
      });
      setShowLeaveModal(true);
      return;
    }

    // If no files, close directly
    setSelectedFiles([]);
    setSelecteditem(null);
    setFirstDone(false);
    setSecondDone(false);
    if (supfileInputRef.current) {
      supfileInputRef.current.value = "";
    }
    closesupplementModal();
  };

  const getFirstLetter = (name) => (name ? name.charAt(0).toUpperCase() : "");

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const agentresponse = await axios.post(`${API_BASE_URL}services`, {
        case_id: selectedFile?.caseId,
        service_id: selectedFile?.caseServiceId,
        mode: "AgentSummary",
      });


      if (agentresponse.data.status === 1) {
        const agentlist = agentresponse.data.message;
        setagentlist(agentlist);
        setogAgentlist(agentlist);
      } else {
        setagentlist([]);
        setogAgentlist([]);
      }

      const agentassistantresponse = await axios.post(`${API_BASE_URL}services`, {
        case_id: selectedFile?.caseId,
        service_id: selectedFile?.caseServiceId,
        mode: "AgentAssistant",
      });


      if (agentassistantresponse.data.status === 1) {
        const agentassistantlist = agentassistantresponse.data.message;
        setagentassistantlist(agentassistantlist);
        setogagentassistantlist(agentassistantlist);
      } else {
        setagentassistantlist([]);
        setogagentassistantlist([]);
      }

      const additionalappsresponse = await axios.post(`${API_BASE_URL}services`, {
        case_id: selectedFile?.caseId,
        service_id: selectedFile?.caseServiceId,
        mode: "AppsFeature",
      });


      if (additionalappsresponse.data.status === 1) {
        const additionalappsList = additionalappsresponse.data.apps_list;
        setadditionalappslist(additionalappsList);
        setogadditionalappslist(additionalappsList);
      } else {
        setadditionalappslist([]);
        setogadditionalappslist([]);
      }
    } catch (err) {
      console.error("Error fetching item details:", err);
      setagentlist([]);
      setogAgentlist([]);
    } finally {
      setLoading(false);
    }
  };
  const handleAgentToggle = (agentId) => {
    setagentlist((prev) =>
      prev.map((agent) =>
        agent.agentSummaryId === agentId
          ? { ...agent, agentIsSelected: agent.agentIsSelected === 1 ? 0 : 1 }
          : agent
      )
    );

    setAgentPrompts((prev) => {
      const updated = { ...prev };
      const toggledAgent = agentlist.find((a) => a.agentSummaryId === agentId);

      if (toggledAgent && toggledAgent.agentIsSelected === 1) {
        delete updated[agentId];
      }

      return updated;
    });
  };
  const handleAgentAssistantToggle = (agentId) => {
    setagentassistantlist((prev) =>
      prev.map((agent) =>
        agent.agentAssistantId === agentId
          ? { ...agent, agentIsSelected: agent.agentIsSelected === 1 ? 0 : 1 }
          : agent
      )
    );
  };
  const handleadditionalappsToggle = (agentId) => {
    setadditionalappslist((prev) =>
      prev.map((agent) =>
        agent.commonAppId === agentId
          ? { ...agent, agentIsSelected: agent.agentIsSelected === 1 ? 0 : 1 }
          : agent
      )
    );
  };

  const scrollRef = useRef(null);

  // Scroll when step or messagesTyping changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [step, messagesTyping]);


  const eligibleAgents = agentlist.filter((a) => {
    const isNowSelected = a.agentIsSelected === 1;
    const wasOriginallySelected = ogAgentlist.some(
      (og) => og.agentSummaryId === a.agentSummaryId && og.agentIsSelected === 1
    );
    return isNowSelected && !wasOriginallySelected && a.summaryUserPromptEnable === 1;
  });

  return (
    <>
      {/* Modal */}
      {issupplementModalOpen && (
        <div className="modal spl-modal fade show supplement-page" style={{ display: 'block', zIndex: 999 }} tabIndex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg  modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="uploadModalLabel">Upload Your Supplement Files</h5>
                <button type="button" className="btn-close" onClick={handleClose} style={{ fontSize: 'large' }}>
                  <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"> <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" /></svg>
                </button>
              </div>
              <div className="modal-body ">
                <div className="btm-chat-wrap text-center w-100" style={{ maxWidth: "100%" }}>
                  <div className="chat-bot-wrapper w-100 h-100 d-flex justify-content-center align-items-center mb-3" style={{ border: '2px dotted #ddd', borderRadius: '12px', minHeight: '178px' }}>
                    <div className="chat-bot-inner  w-100 h-100 flex-column" style={{ display: (selectedFiles) ? "block" : "flex" }}>

                      {isSupfilevalidating ? (
                        <>
                          <Spinner className="custom-spinner mt-2 mx-auto mb-1" animation="border" role="status" />
                          <p>Filevalidating...</p>
                        </>
                      ) : isSupUploading ? (
                        <>
                          <div className="file-upload-area w-100 h-100 d-flex justify-content-center align-items-center">
                            <div className="upload-progress-container mt-2">
                              <div className="progress" style={{ width: '100%', height: '13px' }}>
                                <div
                                  className="progress-bar progress-bar-striped progress-bar-animated"
                                  role="progressbar"
                                  style={{ width: `${SupUploadProgress}%`, height: "10px" }}
                                  aria-valuenow={SupUploadProgress}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {SupUploadProgress}%
                                </div>
                              </div>
                              <p>Uploading... {SupUploadProgress}%</p>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="file-upload-area w-100 h-100 d-flex justify-content-center align-items-center px-0">

                            <label
                              htmlFor="supfile-upload-btn"
                              className="upload-icon d-flex flex-column align-items-center"
                            >
                              <i className="fa-solid fa-arrow-up-from-bracket"></i>
                              <h5 className="my-1">Upload your {localStorage.getItem('userdocumentlabel')
                                ? `${localStorage.getItem('userdocumentlabel').toLowerCase() || 'project'}`
                                : 'project'} here</h5>
                              <a className="fs-6">Browse files</a>
                              <p className='fs-6 mt-2 mb-0'> Kindly ensure that your PDF or ZIP file does not exceed <span className='fw-semibold'>{MAX_FILE_SIZE_MB} MB</span><br className='d-none d-lg-block' />  in size, You can add multiple files.</p>
                            </label>
                            <input
                              type="file"
                              id="supfile-upload-btn"
                              className="file-input"
                              accept="application/pdf, application/zip, application/x-zip-compressed"
                              onChange={handleSupFileInputChange}
                              multiple
                              ref={supfileInputRef}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="uploaded-files-container">
                  {selectedFiles && selectedFiles.length > 0 ? (
                    selectedFiles.map((file, idx) => (
                      <div
                        key={idx}
                        className="uploaded-file-card d-flex align-items-center"
                        style={{
                          opacity: removingFileIndex === idx ? 0.5 : 1,
                        }}
                      >
                        {removingFileIndex === idx && (
                          <div className="file-loader position-absolute top-0 start-0 end-0 bottom-0 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 10 }}>
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        )}
                        <div
                          className="file-close-btn"
                          onClick={() => handleRomove(idx, file.fileName)}
                          style={{
                            pointerEvents: removingFileIndex === idx ? 'none' : 'auto', // Disable button during removal
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width='14' height='14' fill='#fff'> <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" /></svg>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="uploaded-file-icon me-2">
                            <i className="fa-solid fa-file"></i>
                          </div>
                          <div className="file-name">{file.fileName}</div>
                        </div>
                      </div>
                    ))
                  ) : (
                    ""
                  )}

                </div>
                {/* Summary Option */}
                {selectedFiles && selectedFiles.length > 0 && (
                  <>
                    <div className="d-flex justify-content-start gap-1 mt-2">
                      <div
                        className="uploaded-files position-relative mt-1"
                        style={{ border: "unset" }}
                      >
                        {!firstDone ? (
                          <TypingEffect
                            key="step-1"
                            text={`<p class="mb-1">Thank you for uploading supplement files.</p>
                                  <div class='d-flex gap-1'>
                                    <div class="upload-box"><p class="mb-0">You have existing file total pages: ${selecteditem?.casePageCount}</p></div>
                                    <div class="upload-box"><p class="mb-0">You have supplement file total pages: ${selecteditem?.supplement_page}</p></div>
                                  </div>`}
                            speed={20}
                            onComplete={() => setFirstDone(true)}
                          />
                        ) : (
                          <>
                            <p className="mb-1">Thank you for uploading supplement files.</p>
                            <div className="d-flex gap-1">
                              <div className="upload-box">
                                <p className="m-0">You have existing file total pages: {selecteditem?.casePageCount}</p>
                              </div>
                              <div className="upload-box">
                                <p className="m-0">You have supplement file total pages: {selecteditem?.supplement_page}</p>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Second block - total pages + credits */}
                    {firstDone &&
                      <div className="d-flex justify-content-start gap-1 mt-2">
                        <div
                          className="uploaded-files position-relative"
                          style={{ border: "unset" }}
                        >
                          {!secondDone ? (
                            <TypingEffect
                              key="step-2"
                              text={`<div class='d-flex gap-1'>
                              <div class="upload-box"><p class="mb-0">You have total pages: ${selecteditem?.total_page}</p></div>
                              <div class="upload-box"><p class="mb-0">Total credits required: ${selecteditem?.total_page}</p></div>
                            </div>`}
                              speed={20}
                              onComplete={() => setSecondDone(true)}
                            />
                          ) : (
                            <div className="d-flex gap-1">
                              <div className="upload-box d-block">
                                <p className="m-0">You have total pages: {selecteditem?.total_page}</p>
                              </div>
                              <div className="upload-box d-block">
                                <p className="m-0">Total credits required: {selecteditem?.total_page}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    }
                    {(secondDone && step === 1) &&
                      <div className="d-flex justify-content-end mt-3">
                        <button
                          className="btn common-btn d-flex justify-content-center align-items-center    "
                          // onClick={() => {
                          //   if (selectedFiles && selectedFiles.length > 0) {
                          //     handleUpload();
                          //   } else {
                          //     toast.warn("Please select at least onesupplement file.");
                          //   }
                          // }}
                          // disabled={isSuploading}
                          onClick={() => { setStep(2); setMessagesTyping(true); }}

                        >

                          Continue<i className="fa-solid fa-arrow-right ms-1"></i>

                        </button>
                      </div>}


                    {step >= 2 && (
                      <div className="" style={{ height: "auto", marginTop: "2px" }}>
                        <div className="justify-content-start gap-1 mt-2">

                          {messagesTyping && step === 2 ? (
                            <div className='d-flex gap-2'>
                              <div className="profile-dp rounded-circle d-flex justify-content-center align-items-center" title="Profile">
                                {getFirstLetter("AttestaAI")}
                              </div>
                              <TypingEffect
                                key="step-3"
                                text={`<p className='mt-1'>Select the AttestaAI agents:</p>`}
                                speed={25}
                                onComplete={() => setMessagesTyping(false)}
                              />
                            </div>
                          ) : (
                            <>
                              <div className='d-flex gap-2 mt-1'>

                                <div className="profile-dp rounded-circle d-flex justify-content-center align-items-center" title="Profile">
                                  {getFirstLetter("AttestaAI")}
                                </div>
                                <p className='mt-1'>Select the AttestaAI agents:</p>
                              </div>
                              <div className="d-flex justify-content-start gap-1">
                                <div className="job-selection w-100">
                                  <div className="mb-0 w-100">
                                    <div className='additional-agents-inner'
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(175px, 175px))',
                                        rowGap: '20px',
                                        width: '100%',
                                        justifyContent: "start",
                                      }}
                                    >
                                      {agentlist?.map((item) => {
                                        const isSelected = item.agentIsSelected === 1;
                                        const isOriginal = ogAgentlist.some(
                                          (og) => og.agentSummaryId === item.agentSummaryId && og.agentIsSelected === 1
                                        );


                                        return (
                                          <a
                                            className={`avatar-items ${isSelected ? 'active position-relative' : 'position-relative'}`}
                                            key={`summary${item.agentSummaryId}`}
                                            style={{
                                              width: '90%',
                                              padding: '10px 24px 10px 10px',
                                              cursor: 'pointer',
                                              position: 'relative',
                                              // border: isSelected ? "1px solid #007bff" : "1px solid #ddd",
                                              borderRadius: "8px",
                                              backgroundColor: isSelected ? "#f0f8ff" : "#fff",
                                              opacity: isOriginal ? 0.4 : 1,
                                              pointerEvents: isOriginal ? 'none' : 'auto',
                                              cursor: isOriginal ? "not-allowed" : "pointer",
                                            }}
                                            onClick={() => {
                                              if (!isOriginal) {
                                                handleAgentToggle(item.agentSummaryId);
                                                setStep(2);
                                              }
                                            }}

                                          >
                                            {/* Tick */}
                                            {isSelected && (
                                              <span
                                                style={{
                                                  position: 'absolute',
                                                  top: '5px',
                                                  right: '5px',
                                                  background: '#000',
                                                  color: '#fff',
                                                  borderRadius: '50%',
                                                  width: '20px',
                                                  height: '20px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '12px'
                                                }}
                                              >
                                                <i className="fa-solid fa-check"></i>
                                              </span>
                                            )}

                                            {/* Content */}
                                            <div className="text-center d-flex align-items-start">
                                              <div>
                                                <span
                                                  className="custom-icon-doc me-1"
                                                  dangerouslySetInnerHTML={{ __html: item?.summaryPmtIcon }}
                                                ></span>
                                              </div>
                                              <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                                <p className="text-start my-0">{item.summaryPmtLabel}</p>
                                              </div>
                                            </div>
                                          </a>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {showPromptSection && eligibleAgents.length > 0 && (
                                <div className="mt-3 ms-1">

                                  {/* Saved prompts display */}
                                  {Object.entries(agentPrompts).map(([agentId, prompts]) => {
                                    const agent = agentlist.find(
                                      (a) => a.agentSummaryId.toString() === agentId
                                    );
                                    return (
                                      <>


                                        <div
                                          key={agentId}
                                          className="mb-3 p-2 border rounded bg-light d-flex flex-column"
                                        >
                                          <p className="mb-2 fw-semibold">
                                            {agent?.summaryPmtLabel} Instruction
                                          </p>
                                          {prompts.map((prompt, index) => (
                                            <div
                                              key={index}
                                              className="d-flex justify-content-between align-items-start mb-1"
                                            >
                                              <textarea
                                                className="form-control me-2"
                                                rows={2}
                                                value={prompt}
                                                readOnly={
                                                  !(
                                                    editPromptInfo.agentId === agentId &&
                                                    editPromptInfo.index === index
                                                  )
                                                }
                                                onChange={(e) =>
                                                  setAgentPrompts((prev) => {
                                                    const updated = { ...prev };
                                                    updated[agentId][index] = e.target.value;
                                                    return updated;
                                                  })
                                                }
                                              />
                                              <div className="d-flex flex-column">
                                                {editPromptInfo.agentId === agentId &&
                                                  editPromptInfo.index === index ? (
                                                  <i
                                                    className="fas fa-save text-success mb-2"
                                                    style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                    title="Save"
                                                    onClick={() =>
                                                      setEditPromptInfo({ agentId: null, index: null })
                                                    }
                                                  />
                                                ) : (
                                                  <i
                                                    className="fas fa-edit text-warning mb-2"
                                                    style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                    title="Edit"
                                                    onClick={() =>
                                                      setEditPromptInfo({ agentId, index })
                                                    }
                                                  />
                                                )}
                                                <i
                                                  className="fas fa-trash text-danger"
                                                  style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                  title="Delete"
                                                  onClick={() =>
                                                    setAgentPrompts((prev) => {
                                                      const updated = { ...prev };
                                                      if (updated[agentId].length === 1) {
                                                        delete updated[agentId];
                                                      } else {
                                                        updated[agentId].splice(index, 1);
                                                      }
                                                      return updated;
                                                    })
                                                  }
                                                />
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </>
                                    );
                                  })}

                                  {/* Add new prompt */}
                                  {showPromptSection && eligibleAgents.filter((a) => !agentPrompts[a.agentSummaryId]).length > 0 && (
                                    <><h6>Instruct AI Agents</h6>
                                      <select
                                        className="form-select mb-2"
                                        value={selectedPromptAgent}
                                        onChange={(e) => setSelectedPromptAgent(e.target.value)}
                                      >
                                        <option value="">Select Agent</option>
                                        {eligibleAgents
                                          .filter((a) => !agentPrompts[a.agentSummaryId])
                                          .map((agent) => (
                                            <option
                                              key={agent.agentSummaryId}
                                              value={agent.agentSummaryId}
                                            >
                                              {agent.summaryPmtLabel}
                                            </option>
                                          ))}
                                      </select></>)}

                                  {selectedPromptAgent && (
                                    <div className='text-center'>
                                      <textarea
                                        className="form-control"
                                        rows={3}
                                        placeholder="Instruct AI agent..."
                                        value={currentPrompt}
                                        onChange={(e) => setCurrentPrompt(e.target.value)}
                                      ></textarea>
                                      <button
                                        className="btn btn-secondary mt-2 me-2"
                                        onClick={() => {
                                          setCurrentPrompt("");
                                          setSelectedPromptAgent("");
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btn-primary mt-2 "
                                        onClick={() => {
                                          if (!currentPrompt.trim()) return;
                                          setAgentPrompts((prev) => ({
                                            ...prev,
                                            [selectedPromptAgent]: [currentPrompt],
                                          }));
                                          setCurrentPrompt("");
                                          setSelectedPromptAgent("");
                                        }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  )}
                                </div>

                              )}
                              {step === 2 &&
                                <div className="d-flex justify-content-end mt-3 gap-1">
                                  {eligibleAgents.filter((a) => !agentPrompts[a.agentSummaryId]).length > 0 && !showPromptSection && (
                                    <button
                                      className="btn custom-file-button btn-outline-primary"
                                      onClick={() => setShowPromptSection(true)}
                                    >
                                      Instruct AI Agents
                                    </button>
                                  )}
                                  <button
                                    className="btn common-btn d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      setStep(3); setMessagesTyping(true);
                                      setSelectedPromptAgent(null);
                                      // setShowPromptSection(false),
                                      // setAgentPrompts({})
                                    }}

                                  >
                                    <h4 className="mb-0 me-0 fs-5 fw-normal">
                                      Continue<i className="fa-solid fa-arrow-right ms-1"></i>
                                    </h4>
                                  </button>
                                </div>}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    {step >= 3 && (
                      <div className="" style={{ height: "auto", marginTop: "2px" }}>
                        <div className="justify-content-start gap-1 mt-2">
                          {messagesTyping && step === 3 ? (
                            <div className='d-flex gap-2'>
                              <div className="profile-dp rounded-circle d-flex justify-content-center align-items-center" title="Profile">
                                {getFirstLetter("AttestaAI")}
                              </div>
                              <TypingEffect
                                key="step-4"
                                text={`<p>Select the AttestaAI assistants:</p>`}
                                speed={25}
                                onComplete={() => setMessagesTyping(false)}
                              />
                            </div>
                          ) : (
                            <>
                              <div className='d-flex gap-2 mt-1'>
                                <div className="profile-dp rounded-circle d-flex justify-content-center align-items-center" title="Profile">
                                  {getFirstLetter("AttestaAI")}
                                </div>
                                <p className='mt-1'>Select the AttestaAI assistants:</p>
                              </div>
                              <div className="d-flex justify-content-start gap-1">
                                <div className="job-selection w-100">
                                  <div className="mb-0 w-100">
                                    <div className='additional-agents-inner'
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(175px, 175px))',
                                        rowGap: '20px',
                                        width: '100%',
                                        justifyContent: "start",
                                      }}
                                    >
                                      {agentassistantlist?.map((item) => {
                                        const isSelected = item.agentIsSelected === 1;
                                        const isOriginal = ogagentassistantlist.some(
                                          (og) => og.agentAssistantId === item.agentAssistantId && og.agentIsSelected === 1
                                        );


                                        return (
                                          <a
                                            className={`avatar-items ${isSelected ? 'active position-relative' : 'position-relative'}`}
                                            key={`assistant${item.agentAssistantId}`}
                                            style={{
                                              width: '90%',
                                              padding: '5px',
                                              cursor: 'pointer',
                                              position: 'relative',
                                              margin: '5px',
                                              borderRadius: "8px",
                                              backgroundColor: isSelected ? "#f0f8ff" : "#fff",
                                              opacity: isOriginal ? 0.4 : 1,
                                              pointerEvents: isOriginal ? 'none' : 'auto',
                                              cursor: isOriginal ? "not-allowed" : "pointer",
                                            }}
                                            onClick={() => !isOriginal && handleAgentAssistantToggle(item.agentAssistantId)}
                                          >
                                            {/* Tick */}
                                            {isSelected && (
                                              <span
                                                style={{
                                                  position: 'absolute',
                                                  top: '5px',
                                                  right: '5px',
                                                  background: '#000',
                                                  color: '#fff',
                                                  borderRadius: '50%',
                                                  width: '20px',
                                                  height: '20px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '12px'
                                                }}
                                              >
                                                <i className="fa-solid fa-check"></i>
                                              </span>
                                            )}

                                            {/* Content */}
                                            <div
                                              className="text-center"
                                              style={{ display: 'flex', alignItems: 'center', alignContent: 'center', gap: '8px' }}
                                            >
                                              <img
                                                src={item.assistantImg}
                                                alt=""
                                                style={{ width: '50px', height: '50px' }}
                                              />
                                              <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                                <h5 className="mb-1">{item.assistantName}</h5>
                                                <p className="text-start my-0"> {item.assistantLabel}</p>
                                              </div>
                                            </div>
                                          </a>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {step === 3 &&
                                <div className="d-flex justify-content-end mt-3">
                                  <button
                                    className="btn common-btn d-flex justify-content-center align-items-center "
                                    onClick={() => {
                                      // setStep(4); setMessagesTyping(true);
                                      if (ogadditionalappslist?.length > 0) {
                                        setStep(4);
                                        setMessagesTyping(true);
                                      } else {
                                        handleUpload();
                                      }
                                    }}
                                  >
                                    <h4 className="mb-0 me-0 fs-5 fw-normal">
                                      {ogadditionalappslist?.length > 0 ? "Continue" : "Submit"} <i className="fa-solid fa-arrow-right"></i>
                                    </h4>
                                  </button>
                                </div>}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    {step >= 4 && (
                      <div className="" style={{ height: "auto", marginTop: "2px" }}>
                        <div className="justify-content-start gap-1 mt-2">
                          {messagesTyping && step === 4 ? (
                            <div className='d-flex gap-2'>
                              <div className="profile-dp rounded-circle d-flex justify-content-center align-items-center" title="Profile">
                                {getFirstLetter("AttestaAI")}
                              </div>
                              <TypingEffect
                                key="step-5"
                                text={`<p>Select the additional AttestaAI agents:/p>`}
                                speed={25}
                                onComplete={() => setMessagesTyping(false)}
                              />
                            </div>
                          ) : (
                            <>
                              <div className='d-flex gap-2 mt-1'>
                                <div className="profile-dp rounded-circle d-flex justify-content-center align-items-center" title="Profile">
                                  {getFirstLetter("AttestaAI")}
                                </div>
                                <p className='mt-1'>Select the additional AttestaAI agents:</p>
                              </div>
                              <div className="d-flex justify-content-start gap-1">
                                <div className="job-selection w-100">
                                  <div className="mb-0 w-100">
                                    <div className='additional-agents-inner'
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(175px, 175px))',
                                        rowGap: '20px',
                                        width: '100%',
                                        justifyContent: "start",
                                      }}
                                    >
                                      {additionalappslist?.map((item) => {
                                        const isSelected = item.agentIsSelected === 1;
                                        const isOriginal = ogadditionalappslist.some(
                                          (og) => og.commonAppId === item.commonAppId && og.agentIsSelected === 1
                                        );


                                        return (
                                          <a
                                            className={`avatar-items ${isSelected ? 'active position-relative' : 'position-relative'}`}
                                            key={`assistant${item.commonAppId}`}
                                            style={{
                                              width: '90%',
                                              padding: '5px',
                                              cursor: 'pointer',
                                              position: 'relative',
                                              margin: '5px',
                                              borderRadius: "8px",
                                              backgroundColor: isSelected ? "#f0f8ff" : "#fff",
                                              opacity: isOriginal ? 0.4 : 1,
                                              pointerEvents: isOriginal ? 'none' : 'auto',
                                              cursor: isOriginal ? "not-allowed" : "pointer",
                                            }}
                                            onClick={() => !isOriginal && handleadditionalappsToggle(item.commonAppId)}
                                          >
                                            {/* Tick */}
                                            {isSelected && (
                                              <span
                                                style={{
                                                  position: 'absolute',
                                                  top: '5px',
                                                  right: '5px',
                                                  background: '#000',
                                                  color: '#fff',
                                                  borderRadius: '50%',
                                                  width: '20px',
                                                  height: '20px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '12px'
                                                }}
                                              >
                                                <i className="fa-solid fa-check"></i>
                                              </span>
                                            )}

                                            {/* Content */}
                                            <div
                                              className="text-center"
                                              style={{ display: 'flex', alignItems: 'center', alignContent: 'center', gap: '8px' }}
                                            >
                                              <div>
                                                <span
                                                  className="custom-icon-doc me-1"
                                                  dangerouslySetInnerHTML={{ __html: item?.appIcon }}
                                                ></span>
                                              </div>
                                              <div className="d-flex flex-column text-left align-items-start agents-info text-black">

                                                <p className="text-start my-0"> {item.appName}</p>
                                              </div>
                                            </div>
                                          </a>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {step === 4 &&
                                <div className="d-flex justify-content-end mt-3">
                                  <button
                                    className="btn common-btn d-flex justify-content-center align-items-center "
                                    onClick={() => {
                                      if (selectedFiles && selectedFiles.length > 0) {
                                        handleUpload();
                                      } else {
                                        toast.warn("Please select at least one supplement file.");
                                      }
                                    }}
                                  // disabled={isUploading}
                                  >
                                    <h4 className="mb-0 me-0 fs-5 fw-normal">
                                      Submit <i className="fa-solid fa-arrow-right"></i>
                                    </h4>
                                  </button>
                                </div>}
                            </>
                          )}
                        </div>
                      </div>
                    )}


                  </>
                )}
              </div>
            </div>
          </div>
          <>
            <div ref={scrollRef} style={{ height: 1 }} /></>
        </div>
      )}


      <Modal show={showLeaveModal} onHide={() => setShowLeaveModal(false)}
        centered
        backdrop="static"
        dialogClassName="custom-leave-modal"
        className="upload-mgs-modal"
      >
        {/* <Modal.Header closeButton className="border-0 mb-0">
                <Modal.Title className="modal-title">Upload in Progress</Modal.Title>
              </Modal.Header> */}
        <Modal.Body className="text-center">
          <div className="">

            <p className="mb-0"> You currently have supplement files uploading in progress. </p>
            <p className="mb-0"> Leaving this page will interrupt your upload process. </p>
            <p className="mb-0"> Do you still want to leave? </p>

          </div>
          <div className="mt-4 d-flex justify-content-center gap-2">

            <Button
              className="leave-btn m-0"
              onClick={() => {
                setShowLeaveModal(false);
                if (pendingAction) pendingAction();
              }}
            >
              Yes, Leave
            </Button>
            <Button
              className="stay-btn m-0"
              onClick={() => setShowLeaveModal(false)}
            >
              No, Stay Here
            </Button>
          </div>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default FileUploadModal;
